import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

import {
  CreateProjectRequestPayload,
  CreateProjectResponse,
} from './create-project'

export interface EditRegionsPayload {
  insertRegions: string[]
  deactivateRegions: number[]
}

export interface EditProjectRequestPayload
  extends Omit<CreateProjectRequestPayload, 'regions'> {
  regions: EditRegionsPayload
}

export type EditProjectResponse = CreateProjectResponse

export async function editProject(
  id: number,
  payload: EditProjectRequestPayload,
) {
  const { data } = await companiesApi.put<EditProjectResponse>(
    apiRoutes.editProject(id),
    {
      project: payload,
      users: [],
    },
  )

  return data
}
